(function() { window.GUID_5b6b9720_01e6_4876_a18e_bb17d7cd448e = { getGuid: function() { return "5b6b9720-01e6-4876-a18e-bb17d7cd448e"; } }; })();
var CS;
(function (CS) {
    class CSRotator {
        constructor(rotator) {
            this.ActualItemIndex = 0;
            this.ActualItem = null;
            this.TimerIndex = null;
            this.translateAlreadyCalled = false;
            let me = this;
            this.Rotator = rotator;
            if (rotator[0] != null && rotator[0].id != null) {
                eval('document.' + rotator[0].id + '=me;');
            }
            this.RotatorItems = this.Rotator.children();
            this.RotatorItems.detach();
            this.Rotator.show();
            this.BindDocumentResize();
            this.ForceRefreshEventOnlyOneItem = this.Rotator.data('forcerefresheventonlyoneitem') == "True";
            this.FadeValue = parseInt(this.Rotator.data('fadevalue'), 10);
            this.Cycle();
            this.bindEvent();
        }
        bindEvent() {
            let me = this;
            this.Rotator.off('click');
            this.Rotator.on('click', function (e) {
                if (me.ActualItem != null) {
                    var url = me.ActualItem.data('url');
                    if (url != null && url != "") {
                        window.open(url, '_blank');
                    }
                }
            });
        }
        BindDocumentResize() {
            var me = this;
            CS.win.resize(function () {
                CS.AutoSetScaleClass(me.ActualItem);
            });
        }
        ReplaceContent(html) {
            let me = this;
            me.Rotator.empty();
            me.ActualItemIndex = 0;
            me.Rotator.append(html);
            me.RotatorItems = me.Rotator.children();
            me.RotatorItems.detach();
            me.Cycle();
        }
        Cycle() {
            var me = this;
            if (me.ActualItem != null) {
                me.ActualItem.detach();
            }
            me.ActualItem = $(me.RotatorItems[me.ActualItemIndex]);
            if (me.ActualItem.length > 0) {
                if (IsDefined(typeof (me.ActualItem[0].src))) {
                    var url = me.ActualItem[0].src;
                    var layout = new CS.LayoutElement(CS.body);
                    if (url.indexOf('?') == -1) {
                        url += "?";
                    }
                    if (url.indexOf('screenWidth=') == -1) {
                        url += "&screenWidth=" + layout.Width + "&screenHeight=" + layout.Height;
                    }
                    me.ActualItem[0].src = url;
                }
            }
            if (me.FadeValue == 0) {
                me.ActualItem.hide().appendTo(me.Rotator).show();
            }
            else {
                me.ActualItem.hide().appendTo(me.Rotator).fadeIn(me.FadeValue);
            }
            var result = CS.AutoSetScaleClass(me.ActualItem);
            if (me.ActualItemIndex == me.RotatorItems.length - 1) {
                me.ActualItemIndex = 0;
            }
            else {
                me.ActualItemIndex += 1;
            }
            var interval = me.ActualItem.data('rotatortime') * 1000;
            //Ici, le resultat va valoir false si jamais l'element avait une dimension de 0, donc, qu'il n'était
            //pas encore loader. A ce moment, je load le prochain presque toute suite.
            if (result == false && me.Rotator.is(':visible')) {
                interval = 100;
            }
            if (me.TimerIndex != null) {
                clearTimeout(me.TimerIndex);
            }
            if (me.RotatorItems.length > 1 || me.ForceRefreshEventOnlyOneItem) {
                me.TimerIndex = setTimeout(function () {
                    me.Cycle();
                }, interval);
            }
        }
    }
    CS.CSRotator = CSRotator;
})(CS || (CS = {}));
/*
CS.CSRotator = function (rotator) {
    var me = this;
    this.Rotator = rotator;

    if (rotator[0] != null && rotator[0].id != null) {
        eval('document.' + rotator[0].id + '=me;');
    }

    this.RotatorItems = this.Rotator.children();
    this.RotatorItems.detach();
    this.Rotator.show();
    this.ActualItemIndex = 0;
    this.ActualItem = null;
    this.TimerIndex = null;

    this.BindDocumentResize();
    this.ForceRefreshEventOnlyOneItem = this.Rotator.data('forcerefresheventonlyoneitem') == "True";
    this.FadeValue = parseInt(this.Rotator.data('fadevalue'));

    this.Cycle();

    this.Rotator.off('click');
    this.Rotator.on('click', function (e) {
        if (me.ActualItem != null) {
            var url = me.ActualItem.data('url');
            if (url != null && url != "") {
                window.open(url, '_blank');
            }
        }
    });

};

CS.CSRotator.prototype = function () {

    var translateAlreadyCalled = false;
    var BindDocumentResize = function () {
        var me = this;
        CS.win.resize(function () {
            CS.AutoSetScaleClass(me.ActualItem);
        });
    },


 ReplaceContent = function (html) {
     var me = this;

     me.Rotator.empty();
     me.ActualItemIndex = 0;
     me.Rotator.append(html);
     me.RotatorItems = me.Rotator.children();
     me.RotatorItems.detach();
     me.Cycle();
 },


Cycle = function () {
    var me = this;

    if (me.ActualItem != null) {
        me.ActualItem.detach();
    }

    me.ActualItem = $(me.RotatorItems[me.ActualItemIndex]);

    if (me.ActualItem.length > 0) {
        if (IsDefined(typeof (me.ActualItem[0].src))) {
            var url = me.ActualItem[0].src;
            var layout = new CS.LayoutElement(CS.body);
            if (url.indexOf('?') == -1) {
                url += "?";
            }

            if (url.indexOf('screenWidth=') == -1) {
                url += "&screenWidth=" + layout.Width + "&screenHeight=" + layout.Height;
            }
            me.ActualItem[0].src = url;
        }
    }

    if (me.FadeValue == 0) {
        me.ActualItem.hide().appendTo(me.Rotator).show();
    }
    else {
        me.ActualItem.hide().appendTo(me.Rotator).fadeIn(me.FadeValue);
    }

    var result = CS.AutoSetScaleClass(me.ActualItem);

    if (me.ActualItemIndex == me.RotatorItems.length - 1) {
        me.ActualItemIndex = 0;
    }
    else {
        me.ActualItemIndex += 1;
    }

    var interval = me.ActualItem.data('rotatortime') * 1000;

    //Ici, le resultat va valoir false si jamais l'element avait une dimension de 0, donc, qu'il n'était
    //pas encore loader. A ce moment, je load le prochain presque toute suite.
    if (result == false && me.Rotator.is(':visible')) {
        interval = 100;
    }

    if (me.TimerIndex != null) {
        clearTimeout(me.TimerIndex);
    }

    if (me.RotatorItems.length > 1 || me.ForceRefreshEventOnlyOneItem) {
        me.TimerIndex = setTimeout(function () {
            me.Cycle();
        }, interval);
    }

};

    return {
        ReplaceContent: ReplaceContent,
        Cycle: Cycle,
        BindDocumentResize: BindDocumentResize
    };

}();

*/ 

//# sourceMappingURL=cs.rotator.js.map
